export default (theme) => ({
    list: {
        width: 350,
        background: '#f5f5f5',
        '& .MuiListItemIcon-root' : {
            color: '#3f51b5',
            minWidth: 'initial',
        },
        '& .MuiSvgIcon-root' : {
            color: '#3f51b5',
        },
        [theme.breakpoints.down(376)]: {
            width: 300,
        },
        [theme.breakpoints.down(321)]: {
            width: 270,
        },
    },
    listItem: {
        paddingLeft: '0px',
        position: 'relative',
    },
    listItem_icon: {
        padding: '0px 25px',
        '& svg': {
            width: '34px',
            height: '34px',
        },
    },
    icon_location: {
        '& svg': {
            color: '#e8b32e !important',
        },
        '&::before': {
            content: '""',
            width: '3px',
            height: '100%',
            backgroundColor: '#e8b32e',
            position: 'absolute',
            top: 0,
            left: '1px',
        },
    },
    listItem_text: {
        flex: 'inherit',
        '& + .MuiSvgIcon-root': {
            width: '30px',
            height: '30px',
            color: '#9e9e9e',
        }
    },
    text_location: {
        '& span': {
            fontWeight: 500,
        },
    },
    nested: {
        padding: '8px 0px',
        paddingLeft: '15px',
        marginLeft: '84px',
        position: 'relative',
        width: 'calc(100% - 84px)',
        '&::before': {
            content: '""',
            width: '2px',
            fontSize: '0.75rem',
            height: '100%',
            backgroundColor: '#d8d8d8',
            position: 'absolute',
            top: 0,
            left: '-43px',
            color: '#d8d8d8',
        },
        '& .MuiListItemText-root': {
            flex: 'initial',
            position: 'relative',
            '& .MuiTypography-root': {
                whiteSpace: 'initial',
            },
            '&::before': {
                content: '""',
                backgroundColor: '#d8d8d8',
                position: 'absolute',
                top: 'calc(50% - 3px)',
                left: '-60px',
                color: '#d8d8d8',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
            },
        },
        '&[style]': {
            '& .MuiListItemText-root': {
                '&::before': {
                    backgroundColor: 'var(--status-color)',

                },
            },
        },
        '& .MuiBadge-root': {
            width: 'calc(100% - 35px)',
            '&[style]': {
                '& .MuiBadge-badge': {
                    backgroundColor: 'var(--status-color)',
                    color: 'var(--color)'
                },
            },
            '& .MuiBadge-badge': {
                top: '50%',
                left: '-57px',
                color: '#212121',
                backgroundColor: '#e8b32e',
                '& .MuiTypography-root.MuiTypography-caption': {
                    fontWeight: 'bold',
                },
            },
        },
    },
    subItemsList: {
        '& .MuiButtonBase-root.MuiListItem-root:first-child': {
            '&::before': {
                height: '50%',
                top: '50%',
            },
        },
        '& .MuiButtonBase-root.MuiListItem-root:last-child': {
            '&::before': {
                height: '50%',
            },
        },
        '& .MuiButtonBase-root.MuiListItem-root:only-child': {
            '&::before': {
                display: 'none',
            },
        },
    },
    ordersChangeStatus: {
        '& .MuiBadge-badge': {
            border: '6px solid #e8b32e',
            background: '#212121',
            padding: '2px',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            top: '5px',
            left: '10px',
        },
    },
    nested_location: {
        backgroundColor: '#e8eaf6',
        '& .MuiListItemText-root span': {
            fontWeight: 500,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        ...theme.mixins.toolbar,
    },

    drawer: {
        width: 250,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        flex: 'none',
    },
    drawerOpen: {
        width: 357,
        background: '#f5f5f5',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
        '& + #content-wrapper' : {
            width: 'calc(100% - 357px) !important',
        }
    },
    drawerClose: {
        background: '#f5f5f5',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: 0
        },
        width: '84px',
        '& + #content-wrapper' : {
            width: 'calc(100% - 84px) !important',
        }
    },
});
